import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { IGeneralInfoState } from "types/store";

const initialState: IGeneralInfoState = {
  hideInactiveProcedures: true,
  hideInactiveBrands: true,
  hideInactiveProducts: true,
  clientsQuery: null,
};

const generalInfoSlice = createSlice({
  name: "generalInfo",
  initialState,
  reducers: {
    setHideInactiveProcedures(state, action: PayloadAction<boolean>) {
      state.hideInactiveProcedures = action.payload;
    },
    setHideInactiveProducts(state, action: PayloadAction<boolean>) {
      state.hideInactiveProducts = action.payload;
    },
    setHideInactiveBrands(state, action: PayloadAction<boolean>) {
      state.hideInactiveBrands = action.payload;
    },
    setClientsQuery(state, action: PayloadAction<string | null>) {
      state.clientsQuery = action.payload;
    },
  },
  extraReducers: (builder) => {},
});

export const {
  setHideInactiveProcedures,
  setHideInactiveProducts,
  setHideInactiveBrands,
  setClientsQuery,
} = generalInfoSlice.actions;

export default generalInfoSlice.reducer;
